import DisplayWrapper from "@/components/wrappers/DisplayWrapper";
import { useFilterSearchParams } from "@/utils/hooksUtils";
import { appendSearchParamsToURL } from "@/utils/utils";
import { Card, Col, Row } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";
import { useFilterCommissions } from "../../../../common/api/queries";
import BackNavigationArrow from "../../../../common/components/views/BackNavigationArrow";
import { PageSizes } from "../../../../common/constants";
import { TwoLevelEntityIdObject } from "../../../../common/types";
import { DEFAULT_FILTER_COMMISSIONS_QUERY_PARAMS } from "../api";
import BatchCommissionFilterForm from "../components/forms/filter/BatchCommissionFilterForm";
import { BatchCommissionsTable } from "../components/tables/BatchCommissionsTable";
import { CommissionsFilterPageRequest } from "../types";

export const CommissionsBatchInputImportsContainer = () => {
  const { t } = useTranslation();

  const { id1, id2 } = useParams<TwoLevelEntityIdObject>() as { id1: string; id2: string };
  const navigate = useNavigate();

  const searchParams = useFilterSearchParams<CommissionsFilterPageRequest>({
    params: ["processingResult", "postponementReasons"],
    pageSize: PageSizes.HUGE,
    defaultQueryParamsObject: DEFAULT_FILTER_COMMISSIONS_QUERY_PARAMS,
  });

  const { data } = useFilterCommissions({ id: id1, object: { ...searchParams, sourceIds: [id2] } });

  const handleFilterSubmit = (filter: CommissionsFilterPageRequest) => {
    navigate(appendSearchParamsToURL({ ...filter, pageIndex: undefined }), { replace: true });
  };

  return (
    <DisplayWrapper itemLoaded={!!data?.batch}>
      {data?.batch ? (
        <>
          <Card
            className="card-box"
            title={
              <BackNavigationArrow>
                <h2>
                  {t("commissions.batch.titles.inputImports", {
                    filename: data.sources[0]?.file?.filename || "",
                  })}
                </h2>
                <span className="sub-header-info normal-font-size">
                  {t("commissions.batch.titles.batchDetail", { name: data.batch.name })}
                </span>
              </BackNavigationArrow>
            }
          >
            <Row justify="center">
              <Col flex="1000px">
                <BatchCommissionFilterForm filter={searchParams} onFilterSubmit={handleFilterSubmit} />
              </Col>
            </Row>
          </Card>

          <Card className="card-box">
            <BatchCommissionsTable batch={data.batch} filterData={{ ...searchParams, sourceIds: [id2] }} />
          </Card>
        </>
      ) : undefined}
    </DisplayWrapper>
  );
};
